import classNames from 'classnames';
import React, { useState } from 'react';
import EfDialogYoutube from '../ef-dialog-youtube';
import EfImg from '../ef-img';
import './index.scss';

export interface EfVideoListItemProps {
    /**
     * 图片链接
     */
    pc: string;
    /**
     * 视频播放链接
     */
    src: string;
    /**
     * 标题
     */
    title?: string;
}
interface EfVideoListProps {
    /**
     * 列表
     */
    list?: EfVideoListItemProps[];

    /**
     * 样式名
     */
    className?: string;
}

/**
 * 维护:谢保林
 *
 * 视频列表
 */
const EfVideoList: React.FC<EfVideoListProps> = ({ list, className }) => {
    const prefixCls = `ef-video-list`;
    const classes = classNames(prefixCls, 'ef-container', {
        [`${className}`]: className,
    });
    if (!list?.length) {
        return null;
    }
    const [isPlay, setIsPlay] = useState(false); // 点击播放
    const [activeItem, setActiveItem] = useState<EfVideoListItemProps>({
        pc: '',
        src: '',
    });

    // 点击播放
    const openPlayHandle = (item: EfVideoListItemProps) => {
        setIsPlay(true);
        setActiveItem(item);
    };
    const closePlayHandle = () => {
        setIsPlay(false);
        setActiveItem({
            pc: '',
            src: '',
        });
    };
    return (
        <div className={classes}>
            {list?.map((item: EfVideoListItemProps, index: number) => {
                return (
                    <div
                        key={index}
                        className={`${prefixCls}-item`}
                        onClick={() => {
                            openPlayHandle(item);
                        }}
                    >
                        <div className={`${prefixCls}-img`}>
                            <EfImg pc={item.pc} />
                            <span className={`${prefixCls}-play`}></span>
                        </div>
                        <div className={`${prefixCls}-title`}>{item.title}</div>
                    </div>
                );
            })}
            {isPlay && <EfDialogYoutube open={isPlay} callback={closePlayHandle} src={activeItem.src} />}
        </div>
    );
};

export default EfVideoList;
